import {
    FETCH_USERS,
    FETCH_USERS_FAIL,
    FETCH_USERS_SUCCESS
} from './actionTypes';

export const fetchUsers = () => ({
    type: FETCH_USERS
});

export const fetchUsersSuccess = users => ({
    type: FETCH_USERS_SUCCESS,
    payload: users
});

export const fetchUsersFail = error => ({
    type: FETCH_USERS_FAIL,
    payload: error
});
